import { render, staticRenderFns } from "./typingFourth.vue?vue&type=template&id=0221c209&scoped=true&"
import script from "./typingFourth.vue?vue&type=script&lang=js&"
export * from "./typingFourth.vue?vue&type=script&lang=js&"
import style0 from "./typingFourth.vue?vue&type=style&index=0&id=0221c209&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221c209",
  null
  
)

export default component.exports